import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";
import { LearningObjective } from "../model/model";
import { LearningObjectiveService } from "../services/learning-objective.service";

export class LoadLearningObjectiveInfoAction {
  static type = "[Learning Objective Info] Load";
  constructor(public learningObjectiveCode: string) {}
}

export class UnLoadLearningObjectiveInfoAction {
  static type = "[Learning Objective Info] UnLoad";
  constructor() {}
}

export class LoadInstructionAction {
  static type = "[Learning Objective Info] Load instruction]";
}

export interface LearningObjectiveInfoStateModel {
  loading: boolean;
  loadingInstruction: boolean;
  instructionVideo: string;
  learningObjective: LearningObjective;
}

export const initialState = {
  loading: true,
  loadingInstruction: false,
  instructionVideo: null,
  learningObjective: null,
};
@State<LearningObjectiveInfoStateModel>({
  name: "learningObjectiveInfo",
  defaults: initialState,
})
@Injectable()
export class LearningObjectiveInfoState {
  constructor(private learningObjectiveService: LearningObjectiveService) {}

  @Selector()
  static info(state: LearningObjectiveInfoStateModel) {
    return state.learningObjective ? state : null;
  }

  @Action(LoadLearningObjectiveInfoAction)
  load(ctx: StateContext<LearningObjectiveInfoStateModel>) {
    ctx.patchState({ loading: true });
  }
  @Action(LoadLearningObjectiveInfoAction)
  loading(
    ctx: StateContext<LearningObjectiveInfoStateModel>,
    action: LoadLearningObjectiveInfoAction
  ) {
    return this.learningObjectiveService
      .byCode(action.learningObjectiveCode)
      .pipe(
        tap((learningObjective) => {
          ctx.patchState({
            loading: false,
            learningObjective: learningObjective,
          });
          ctx.dispatch(new LoadInstructionAction());
        })
      );
  }

  @Action(UnLoadLearningObjectiveInfoAction)
  unLoad(
    ctx: StateContext<LearningObjectiveInfoStateModel>,
    action: UnLoadLearningObjectiveInfoAction
  ) {
    return ctx.patchState(initialState);
  }

  @Action(LoadInstructionAction)
  loadInstruction(ctx: StateContext<LearningObjectiveInfoStateModel>) {
    ctx.patchState({ loadingInstruction: true });
  }

  @Action(LoadInstructionAction)
  loadingInstruction(ctx: StateContext<LearningObjectiveInfoStateModel>) {
    if (ctx.getState().learningObjective.hasLaatEensZienClip) {
      return this.learningObjectiveService
        .getInstruction(ctx.getState().learningObjective.id)
        .pipe(
          tap((url) =>
            ctx.patchState({ loadingInstruction: false, instructionVideo: url })
          )
        );
    }
  }
}
